import * as React from 'react';
import {MODAL_COMPONENTS as MODAL_COMPONENTS_WIZARD} from '../../../wizard/constants/ModalConstants';
import {MODAL_COMPONENTS as MODAL_COMPONENTS_ADMIN} from '../../../admin/constants/ModalConstants';
import {MODAL_COMPONENTS as MODAL_COMPONENTS_QUOTE} from '../../../quote/constants/ModalConstants';
import {MODAL_COMPONENTS as MODAL_COMPONENTS_WIZARD_KUNA} from '../../../wizard-kuna/constants/ModalConstants';
import {MODAL_COMPONENTS as MODAL_COMPONENTS_WIZARD_FARRERA} from '../../../wizard-farrera/constants/ModalConstants';
import {MODAL_COMPONENTS as MODAL_COMPONENTS_WIZARD_SEMINUEVOS} from '../../../wizard-seminuevos/constants/ModalConstants';
import {ModalProps} from '../../types/reducers';
import CloseIcon from '../CloseIcon';
import { Size } from '../../types/common';

export default class ModalComponent extends React.Component<ModalProps, {}> {

    static defaultProps = {
        isVisible: false,
        isVisible2: false,
        header: {title: '', closeBtn: true},
        header2: {title: '', closeBtn: true},
        options2: {size: 'small' as Size, closeOnOverlayClick: false},
        content2: {type: null, data: null},
    };

    constructor(props) {
        super(props);
    }

    renderOverlay = (id, isVisible, options) => isVisible ?
        <div key={`backdrop${id}`} id={`backdrop${id}`}
             className={`modal-backdrop show ${id === 'back2' ? 'over' : ''} ${options.customClass}`}/> : null

    renderModal = (isFirst, visibilityClass, options, closeModal, sizeClass,
                   ModalTypeComponent, header, content, footerClass, footer, index, isVisible) =>
        (<div key={`modal${index}`} id={`modal${index}`} className="modal"
              tabIndex={index} style={visibilityClass}
              onClick={() => options.closeOnOverlayClick ? closeModal(isFirst) : undefined}>
            <div className={`modal-dialog align-items-center ${sizeClass}
             ${isVisible ? 'd-flex align-item-center h-100' : ''}`}
                 onClick={e => e.stopPropagation()}>
                <div className={`modal-content ${options.customClass}`}>
                    {header &&
                    <div className="modal-header px-0 pb-0">
                        <h5 className="modal-title" id="exampleModalLiveLabel">{header.title}</h5>
                        {header.closeBtn &&
                        <button type="button" onClick={() => closeModal(isFirst)} className="close">
                                <span>
                                    <CloseIcon color={options.closeColor}/>
                                </span>
                        </button>
                        }
                    </div>
                    }
                    <div className="modal-body my-0 py-0">
                        {ModalTypeComponent && <ModalTypeComponent data={content.data}/>}
                    </div>
                    {footer &&
                    <div className={`modal-footer ${footerClass}`}>
                        {footer.cancelBtn &&
                        <button type="button" className="btn rounded btn-outline-info px-3 px-sm-5"
                                onClick={footer.onPressCancelBtn}>
                            {footer.cancelBtn.toUpperCase()}
                        </button>
                        }
                        {footer.acceptBtn &&
                        <button type="button" className="btn rounded btn-info px-3 px-sm-5"
                                onClick={footer.onPressAcceptBtn}>
                            {footer.acceptBtn.toUpperCase()}
                        </button>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>)

    render() {
        const {
            isVisible, header, footer, content, options, closeModal,
            isVisible2, header2, footer2, content2, options2
        } = this.props;

        const visibilityClass = {overflowY: 'auto', display: isVisible ? 'block' : 'none'} as React.CSSProperties;
        const visibilityClass2 = {overflowY: 'auto', display: isVisible2 ? 'block' : 'none'} as React.CSSProperties;

        const sizeClass = options.size === 'small' ? 'modal-sm' :
            options.size === 'large' ? 'modal-lg' : options.size === 'full' ? 'modal-full' : '';
        const sizeClass2 = options2.size === 'small' ? 'modal-sm' :
            options2.size === 'large' ? 'modal-lg' : options2.size === 'full' ? 'modal-full' : '';

        const footerClass = footer && (footer.align === 'left' ? 'justify-content-start' :
            footer.align === 'center' ? 'justify-content-center' : '');
        const footerClass2 = footer2 && (footer2.align === 'left' ? 'justify-content-start' :
            footer2.align === 'center' ? 'justify-content-center' : '');

        const ModalTypeComponent = {
            ...MODAL_COMPONENTS_WIZARD,
            ...MODAL_COMPONENTS_ADMIN,
            ...MODAL_COMPONENTS_QUOTE,
            ...MODAL_COMPONENTS_WIZARD_KUNA,
            ...MODAL_COMPONENTS_WIZARD_FARRERA,
            ...MODAL_COMPONENTS_WIZARD_SEMINUEVOS}[content.type];
        const ModalTypeComponent2 = {
            ...MODAL_COMPONENTS_WIZARD,
            ...MODAL_COMPONENTS_ADMIN,
            ...MODAL_COMPONENTS_QUOTE,
            ...MODAL_COMPONENTS_WIZARD_KUNA,
            ...MODAL_COMPONENTS_WIZARD_FARRERA,
            ...MODAL_COMPONENTS_WIZARD_SEMINUEVOS}[content2.type];

        const index = -1;
        const index2 = 10;
        const show = document.getElementById(`modal${index}`);
        const show2 = document.getElementById(`modal${index2}`);

        !!show ? isVisible ? show.classList.add('show', 'modal-open') :
            show.classList.remove('show', 'modal-open') : '';
        !!show2 ? isVisible2 ? show2.classList.add('show', 'modal-open') :
            show2.classList.remove('show', 'modal-open') : '';

        return [
            this.renderOverlay('back1', isVisible, options),
            this.renderModal(true, visibilityClass, options, closeModal, sizeClass,
                ModalTypeComponent, header, content, footerClass, footer, index, isVisible),
            this.renderOverlay('back2', isVisible2, options2),
            this.renderModal(false, visibilityClass2, options2, closeModal, sizeClass2,
                ModalTypeComponent2, header2, content2, footerClass2, footer2, index2, isVisible2),
        ];
    }
}
